module.exports = __webpack_public_path__ + "img/pf.96661a7f.png";